import type { Document, TextRange } from '@gitbook/slate';

/**
 * Check if a `range` is hanging.
 * A "hanging" range is one created when the browser selects from the start of that block to the start of the next block.
 * The range thus "hangs over" into the next block. Often but not exclusively caused by triple click.
 *
 * Source: https://docs.slatejs.org/api/nodes/editor#editor.unhangrange-editor-editor-range-range-options-greater-than-range
 */
export function isHangingRange(range: TextRange, document: Document): boolean {
    const { startOffset, endOffset, startKey, endKey } = range;
    if (startKey && endKey) {
        const startBlock = document.getClosestBlock(startKey);
        const endBlock = document.getClosestBlock(endKey);
        return (
            startOffset === 0 &&
            endOffset === 0 &&
            startKey !== endKey &&
            startKey === startBlock?.getFirstText()?.key &&
            endKey === endBlock?.getFirstText()?.key
        );
    }
    return false;
}
